<template>
  <div class="w-full flex flex-col">
    <template v-if="isPostsPath && hasCollections">
      <div class="w-full my-2">
        {{ $t('home.index.featured_model') }}
      </div>

      <div id="designer-post-collections">
        <template v-if="hasCollections">
          <designer-collection-item
            v-for="collection in sortedCollections.slice(0, 3)"
            :key="collection.id"
            :collection="collection"
            :is_owner="isCollectionOwner"
            @collection-deleted="handleCollectionDeleted">
          </designer-collection-item>
          <a v-if="hasMoreCollections"
            :href="collectionsPath"
            class="w-full inline-block underline text-center text-12px text-grey-3 mx-auto col-span-3">
            {{ $t('post_index_collection.see_more_collections') }}
          </a>
        </template>
        <div v-else-if="isCollectionOwner" class="w-full flex flex-col items-center justify-center">
          <div class="w-12 h-12 icon archive mt-5 lg:mt-10"></div>
          <div class="text-16px my-6">
            {{ $t('post_index_collection.no_collection_list') }}
          </div>
          <a :href="newCollectionPath"
             class="flex items-center justify-center mb-10 text-14px btn btn-secondary rounded-[20px]">
            <div class="w-3 h-3 brightness-150 transform -rotate-45 icon close mr-2"></div>
            {{ $t('post_index_collection.new_collection') }}
          </a>
        </div>
      </div>
      <hr class="w-full border-t mt-6 mb-4 border-grey-1">
    </template>

    <template v-if="isSavedPostsPath && hasSeries">
      <div class="w-full my-2">
        {{ $t('home.navbar.series') }}
      </div>

      <div class="grid grid-cols-1 smd:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-8">
        <template v-for="serie in series" :key="serie.id">
          <serie-board-item :serie="serie"></serie-board-item>
        </template>
      </div>

      <hr class="w-full border-grey-1 mt-6 mb-8">
    </template>

    <div v-if='items.length > 0' class="my-2">
      {{ $t('private_profiles.analytic.all_models') }}
    </div>

    <div id="post-item-collection" class="flex-1">
      <template v-if="items && items.length > 0" v-for="post in items" :key="post.id">
        <post-item :post="post" :is_authenticated="is_authenticated" list-name="creator_profile"></post-item>
      </template>
      <template v-else-if="isPostsLoading" >
        <div class="post-item-loading flex flex-col justify-center items-center w-full h-[50vh] col-span-10">
          <img src="../../../images/icons/loading.png" class="w-6 h-6 ml-2 icon loading-icon"/>
        </div>
      </template>
      <template v-else>
        <div class="flex flex-col justify-center items-center w-full h-[50vh] col-span-10">
          <img src="../../../images/model.svg" class="w-16 h-16" />
          <div class='my-6 text-16px font-bold text-center'>
            {{ $t('public_profiles.collection_empty.post') }}
          </div>
        </div>
      </template>

    </div>
    <!-- 在有 items 且持續加載中，顯示 loading -->
    <template v-if="items.length > 0 && autoload && isPostsLoading">
      <div class="flex flex-col justify-center items-center py-8">
        <div class="text-14px text-grey-3">
          <img src="../../../images/icons/loading.png" class="w-6 h-6 ml-2 icon loading-icon"/>
        </div>
      </div>
    </template>
    <!-- 在有 items 且加載完全後，顯示 No more data -->
    <template v-else-if="items.length > 0 && !autoload && !isPostsLoading">
      <div class="flex flex-col justify-center items-center py-8">
        <div class="text-14px text-grey-3">
          {{ $t('home_post_collection.no_more_data')  }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import { defineComponent } from "vue";

export default defineComponent({
  props: {
    scope: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      currPage: 0,
      autoload: true,
      is_authenticated: false,
      isPostsLoading: false,
      username: '',
      itemsCols: 4,
      itemsRows: 2,
      itemsCount: 8,
      items_not_found: false,
      items_data: [],
      items: [],

      series: [],
      collections: [],
      sortedCollections: [],
      sortOrderIds: [],
      isCollectionsLoading: false,
      totalCollections: 0,
      isCollectionOwner: false,
    };
  },
  computed: {
    isPostsPath() {
      return window.location.pathname.endsWith('/posts')
    },
    isSavedPostsPath() {
      return window.location.pathname.endsWith('/saved_posts')
    },
    hasSeries() {
      return this.series && this.series.length > 0
    },
    hasCollections() {
      return this.sortedCollections && this.sortedCollections.length > 0
    },
    hasMoreCollections() {
      return this.sortedCollections.length > 3
    },
    collectionsPath() {
      const currentPath = window.location.pathname;
      return currentPath.replace('/posts', '/collections');
    },
    newCollectionPath() {
      const currentPath = window.location.pathname;
      return currentPath.replace('/posts', '/collections/new');
    }
  },
  mounted() {
    this.setupItemColsCount()
    this.username = this.getUsernameFromURL();

    if (this.isPostsPath) {
      this.initializeCollections();
    } else if (this.isSavedPostsPath) {
      this.fetchSeries();
    }

    this.fetchItemData(this.currPage, this.itemsCount*2)
    this.currPage += 1

    if (window.isFirefox()) {
        window.addEventListener('scroll', this.handleScrollEvent, true);
      } else {
        window.addEventListener('scroll', this.handleScrollEvent);
      }
  },
  methods: {
    getUsernameFromURL() {
      const url = window.location.href;
      const match = this.scope === 'saved_posts' ? url.match(/\/p\/([^\/]+)\/saved_posts/) : url.match(/\/p\/([^\/]+)\/posts/);
      return match ? match[1] : '';
    },

    collectionsPath() {
      const currentPath = window.location.pathname;
      return currentPath.split('/').slice(0, -2).join('/');
    },

    async fetchItemData(currPage, perPage) {
      const url = "/api/v1/profiles/" + this.username + "/get_" + this.scope
      this.isPostsLoading = true;
      this.items_not_found = false;
      // 資料要往後拉，所以 +1
      let curr_params = {
        page: (currPage || this.currPage) + 1,
        per_page: perPage || this.itemsCount
      };

      try {
        const response = await fetch(
          url + "?" + new URLSearchParams(curr_params)
        );

        if (response.ok) {
          this.isPostsLoading = false;

          const data = await response.json();
          const itemsData = data['data'];
          this.is_authenticated = data['is_authenticated']
          // 如果 params page > resp total_page
          // 等於拉到底了，就不用 autoload 了
          if (curr_params['page'] > data['pagination']['total_pages']) {
            this.autoload = false;
          } else if (itemsData.length > 0) {
            // 如果有資料就要塞到 items 裏面，並更新頁碼
            this.items.push(...itemsData);
            this.currPage++;
          }
        }
      } catch (error) {
        console.log(error);
        this.items = [];
        this.autoload = false;
      }
    },

    async fetchSeries() {
      if (this.isCollectionsLoading) return;

      const url = `/api/v1/profiles/${this.username}/get_saved_series`;

      this.isCollectionsLoading = true;

      try {
        const response = await fetch(url);

        if (response.ok) {
          const data = await response.json();
          this.series = data.data;
        }
      } catch (error) {
        console.log(error);
        this.series = [];
      } finally {
        this.isCollectionsLoading = false;
      }
    },

    async initializeCollections() {
      try {
        await Promise.all([
          this.fetchSortOrderConfig(),
          this.fetchCollections()
        ]);

        // 在兩個數據都載入後，應用排序邏輯
        this.applySortOrder();
      } catch (error) {
        console.error('Error initializing collections:', error);
      }
    },

    // 獲取排序配置
    async fetchSortOrderConfig() {
      try {
        const response = await fetch('/api/v1/profile/orders_config?mode=profile_collections');
        if (response.ok) {
          const data = await response.json();
          this.sortOrderIds = (data.normal || []).map(id => Number(id));
          return this.sortOrderIds;
        }
      } catch (error) {
        console.error('Error fetching sort order config:', error);
        return [];
      }
    },

    async fetchCollections() {
      if (this.isCollectionsLoading) return;

      const url = `/api/v1/profiles/${this.username}/get_designer_collections`;

      let curr_params = {
        mode: 'preview',
        per_page: 5
      };

      this.isCollectionsLoading = true;

      try {
        const response = await fetch(
          url + "?" + new URLSearchParams(curr_params)
        );

        if (response.ok) {
          const data = await response.json();

          this.collections = data.data;
          this.totalCollections = data.pagination.total_count;
          this.isCollectionOwner = data.is_owner;
        }
      } catch (error) {
        console.log(error);
        this.collections = [];
      } finally {
        this.isCollectionsLoading = false;
      }
    },

    // 應用排序邏輯
    applySortOrder() {
      if (this.collections.length === 0) {
        this.sortedCollections = [];
        return;
      }

      if (this.sortOrderIds.length === 0) {
        // 如果沒有排序配置，保持原始順序
        this.sortedCollections = this.collections.map((item, index) => ({
          ...item,
          id: Number(item.id),
          sortOrder: index
        }));
        return;
      }

      // 根據排序配置重新排列
      this.sortedCollections = this.collections.map(collection => {
        const collectionId = Number(collection.id);
        const orderIndex = this.sortOrderIds.indexOf(collectionId);

        return {
          ...collection,
          id: collectionId,
          // 如果不在排序列表中，放到最後
          sortOrder: orderIndex >= 0 ? orderIndex : this.sortOrderIds.length + collectionId
        };
      }).sort((a, b) => a.sortOrder - b.sortOrder);
    },

    setupItemColsCount() {
      if (window.innerWidth >= 1024) {
        this.itemsCols = 4;
      } else if (window.innerWidth >= 780) {
        this.itemsCols = 3;
      } else if (window.innerWidth >= 705) {
        this.itemsCols = 2;
      } else {
        this.itemsCols = 1;
      }

      if (this.itemsCols != 1) {
        this.itemsCount = this.itemsCols * this.itemsRows;
      } else {
        this.itemsCount = 10;
      }
    },

    handleScrollEvent() {
      if (!this.autoload) {
        return;
      }
      const scrollableHeight = document.body.scrollHeight - window.innerHeight - 150;
      const scrolledDistance = Math.max(
        window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop
      );

      if (scrolledDistance >= scrollableHeight) {
        if (!this.isPostsLoading && this.autoload) {
          this.fetchItemData();
        }
      }
    },

    // 處理集合刪除
    handleCollectionDeleted(collectionId) {
      const numericId = Number(collectionId);

      // 從原始數據中移除
      this.collections = this.collections.filter(collection => Number(collection.id) !== numericId);

      // 從排序數據中移除
      this.sortedCollections = this.sortedCollections.filter(collection => Number(collection.id) !== numericId);

      // 更新計數器
      const countElement = document.querySelector('.collections-count');
      if (countElement) {
        countElement.textContent = `(${this.sortedCollections.length})`;
      }
    }
  }
})
</script>
